import React from 'react';
import clsx from 'clsx';
import styles from './StatCard.module.scss';

interface StatCardProps {
    label: string;
    value: React.ReactNode;
    hint?: string;
    delta?: number;
    className?: string;
}

// KPI card following the Enterprise Dashboard pattern (label, big value, delta badge, hint).
export const StatCard: React.FC<StatCardProps> = ({ label, value, hint, delta, className }) => (
    <div className={clsx(styles.root, className)}>
        <span className={styles.label}>{label}</span>
        <div className={styles.valueRow}>
            <span className={styles.value}>{value}</span>
            {delta !== undefined && (
                <span className={clsx(styles.delta, delta >= 0 ? styles.positive : styles.negative)}>
                    {delta >= 0 ? '+' : ''}
                    {delta}%
                </span>
            )}
        </div>
        {hint && <span className={styles.hint}>{hint}</span>}
    </div>
);

export default StatCard;
